/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function CourseIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-course">
        <g id="icon-journey-course">
          <circle
            id="Oval"
            cx="78.5"
            cy="78.5"
            r="77.5"
            fill={mainColor}
            stroke="white"
            stroke-width="2"
          />
        </g>
        <g id="graduate-cap">
          <path
            id="Path"
            d="M133 94.0902C133.047 92.2222 132.025 91.0311 130.638 90.3419V64.4877C130.953 64.3682 131.148 64.0693 131.145 63.7353C131.145 63.4012 130.928 63.1059 130.624 62.9969L77.6206 44.182C76.9428 43.9393 76.2021 43.9393 75.5208 44.182L22.5241 63.0004C22.2132 63.1094 22.0036 63.4047 22.0001 63.7388C21.9966 64.0728 22.1957 64.3717 22.5032 64.4912L75.4265 85.2224C76.1637 85.5072 76.9777 85.5072 77.7149 85.2224L126.984 65.9118V90.3384C125.6 91.0241 124.626 92.427 124.626 94.0831C124.626 95.8131 125.674 97.3145 127.172 97.9579C125.674 100.936 124.626 107.047 124.626 108.791C124.626 111.115 126.502 113 128.811 113C131.117 113 132.993 111.115 132.993 108.791C132.993 107.047 131.941 100.936 130.446 97.9579C131.948 97.3215 132.953 95.9581 133 94.0902Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M39 75C39.0035 80.9966 39.007 88.0538 39.007 89.1747C39.007 100.34 55.6158 109.431 76.5017 110C97.3842 109.431 113.993 100.351 113.993 89.1747C113.993 88.0609 113.993 81.0001 114 75L77.6374 89.3232C76.9001 89.6131 76.0859 89.6131 75.3486 89.3232L39 75Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

CourseIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
CourseIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(CourseIcon);
memoized.displayName = 'CourseIcon';
export default memoized;
